import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ProductAvailabilityLabel from 'src/components/productAvailabilityLabel';
import RootStore from 'src/stores/RootStore';
import { TProductModel } from 'src/stores/types/ProductTypes';

interface SelectStrapProps {
    store?: typeof RootStore.Type;
    selectedStrapCode: string;
    setSelectedStrapCode: (selected: string) => void;
}

const SelectStrap = inject('store')(
    observer(({ store, selectedStrapCode, setSelectedStrapCode }: SelectStrapProps) => {
        const strapList: TProductModel[] | [] = store?.products.strapList;
        const [isOpen, setOpen] = useState(false);
        // This indicate if at least 1 of the parts is in stock, so we don't show user None option
        // const [inStock, setInStock] = useState(false);

        useEffect(() => {
            if (strapList?.length) {
                const defaultValue = strapList.find(part => part.productInformation.inStock);
                if (defaultValue) {
                    setSelectedStrapCode(defaultValue.id);
                    // setInStock(true);
                } else {
                    setSelectedStrapCode('empty');
                }
            }
        }, [strapList]);

        if (!strapList?.length) {
            return null;
        }

        const getOption = (value: string) => {
            const foundOption = strapList.find(part => part.id === value);
            return foundOption ? (
                foundOption.productInformation.color
            ) : (
                <span>
                    <FormattedMessage id="product.straps.empty" />
                </span>
            );
        };

        return (
            <FormControl variant="standard" sx={{ margin: '10px 0 10px', width: '100%' }}>
                <InputLabel htmlFor="strap-item">
                    <FormattedMessage id="select.strap" />
                </InputLabel>
                <Select
                    data-testid="strapSelector"
                    labelId="strap-item"
                    open={isOpen}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={selectedStrapCode}
                    name="selectedStrapColor"
                    displayEmpty={false}
                    renderValue={(value: any) => getOption(value)}
                    onChange={e => setSelectedStrapCode(e.target.value as string)}
                    sx={{ overflow: 'hidden' }}
                >
                    {/* {!inStock && ( */}
                        <MenuItem key="empty" value="empty" data-testid="no-strap">
                            <FormattedMessage id="product.straps.empty">
                                {text => <em>{`${text}`}</em>}
                            </FormattedMessage>
                        </MenuItem>
                    {/* )} */}
                    {strapList.map((part: TProductModel) => (
                        <MenuItem
                            key={part.id}
                            value={part.id}
                            data-testid={`strap-${part.id}`}
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                            disabled={!part.productInformation.inStock && !part.productInformation.availableFrom}
                        >
                            <span>
                                <span>{part.productInformation.color}</span>
                            </span>
                            <ProductAvailabilityLabel
                                inStock={part.productInformation.inStock}
                                availableFrom={part.productInformation.availableFrom}
                                stockQuantity={part.productInformation.stockQuantity}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }),
);

export default SelectStrap;
